export default "__VITE_ASSET__DDdRKRvU__"